import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import classNames from 'classnames';
import Layout from './Layout';

function OrderServicesTypeList(props) {
  const [config, setConfig] = useState({});
  const {
    state,
    setState,
    servicesList
  } = props

  const renderedServicesList = servicesList.map(service => {
    return (
      <button
        type="button"
        className={classNames('services-list__item', {
          'services-list__item--active': service.id === +state.orderServiceTypeId
        })}
        key={service.title}
        onClick={() => {
          setState({
            ...state,
            orderServiceTypeId: service.id
          })
        }}
      >
        <div className="services-list__item__title">{service.title}</div>
        <span className="services-list__item__descr">{service.description}</span>
      </button>
    )
  });

  useEffect(() => {
    setConfig(JSON.parse(document.querySelector('[data-form-config]')?.dataset.formConfig));
  }, [servicesList]);

  return (
    <Layout.Row>
      {servicesList.length > 1 && (
        <div className="services-list" style={{
          gridTemplateColumns: `repeat(${renderedServicesList.length}, 1fr)`
        }}>
          {renderedServicesList}
        </div>
      )}
    </Layout.Row>
  );
}


export default OrderServicesTypeList;
